export const MobileMax = 570

export const HorizontalMobileMax = 760  

export const TabletMax = 1050
